<div class="profile-notification-container">
  <div class="profile-notification" (click)="clickHandler()">
    <div class="profile-notification-title-row">
      <span class="profile-notification-title">{{ title | translate }}</span>
    </div>
    <div class="profile-notification-content" [class.is-clickable]="isClickable" (click)="clickHandler()">
      <icon-component
        *ngIf="isAnomalyNotification"
        [cssClass]="['severity-indicator', 'severity-indicator-' + severity]"
        [iconName]="'record-filled'"
        [toolTipText]="severity"
      ></icon-component>
      <div class="profile-notification-content-text">
        <span class="profile-notification-content-text__title" [ngStyle]="{ 'grid-row': 1 }">Bereich:</span>
        <span
          class="profile-notification-content-text__content"
          [ngStyle]="{ 'grid-row': 1 }"
          [innerHtml]="businessUnit"
        ></span>
        <span class="profile-notification-content-text__title" [ngStyle]="{ 'grid-row': 2 }">Area:</span>
        <span
          class="profile-notification-content-text__content"
          [ngStyle]="{ 'grid-row': 2 }"
          [innerHtml]="area"
        ></span>
      </div>
    </div>
  </div>
  <div class="profile-notification-close">
    <icon-component [iconName]="'close'" [clickable]="true" (iconClicked)="deleteNotification()"></icon-component>
  </div>
</div>
